enum LOCALES {
    EN_US = 'en_US',
    DE_DE = 'de_DE'
}

export default LOCALES

